const DebitNote_Sample = [
  {
    orderData: {
      pct_id: "pct_id",
      store_id: "store_id",
      cmr_phone_number: "cmr_phone_number",
      remarks: "remarks",
      pct_total_gst: "pct_total_gst",
      pct_total_discount: "pct_total_discount",
      pct_payment_status: "pct_payment_status",
      pct_transaction_id: "pct_transaction_id",
      pct_order_status: "pct_order_status",
      pct_payment_method: "pct_payment_method",
      pct_billing_address: "pct_billing_address",
      pct_total_amount: "pct_total_amount",
      pct_round_off_value: "pct_round_off_value",
      pct_sub_total: "pct_sub_total",
      pct_delivery_date: "pct_delivery_date",
      pct_document_date: "pct_document_date",
      cmr_code: "cmr_code",
      cmr_name: "cmr_name",
      cmr_id: "cmr_id",
      created_date: "created_date",
      update_date: "update_date",
      tcs_or_tds_amount: "tcs_or_tds_amount",
      tcs_or_tds_percentage: "tcs_or_tds_percentage",
      tds_tcs_type: "tds_tcs_type",
      tcs_or_tds_percentage_id: "tcs_or_tds_percentage_id",
      pct_invoice_discount: "pct_invoice_discount",
      pct_invoice_discount_percentage: "pct_invoice_discount_percentage",
      pct_is_invoice_dis_percentage: "pct_is_invoice_dis_percentage",
      pct_ship_to_address: "pct_ship_to_address",
      pct_pay_to_address: "pct_pay_to_address",
    },
    itemData: [
      {
        item_id: "item_id",
        poit_id: "poit_id",
        prt_id: "prt_id",
        item_code: "item_code",
        item_generic_name: "item_generic_name",
        item_name: "item_name",
        item_rack_location: "item_rack_location",
        item_unit_price: "item_unit_price",
        item_quantity: "item_quantity",
        item_schedule: "item_schedule",
        item_discount_amount: "item_discount_amount",
        item_discount_percentage: "item_discount_percentage",
        item_tax_amount: "item_tax_amount",
        item_total_tax_percentage: "item_total_tax_percentage",
        item_total_amount: "item_total_amount",
        item_gst: "item_gst",
        item_sgst: "item_sgst",
        item_cgst: "item_cgst",
        item_igst: "item_igst",
        item_uom: "item_uom",
        item_free_quantity: "item_free_quantity",
        item_hsn: "item_hsn",
        item_manufacturer_id: "item_manufacturer_id",
        item_manufacturer_name: "item_manufacturer_name",
        item_pack_size: "item_pack_size",
        base_quantity: "base_quantity",
        itemBatchData: [
          {
            item_id: "item_id",
            item_batch_number: "item_batch_number",
            item_sellable_quantity: "item_sellable_quantity",
            item_non_sellable_quantity: "item_non_sellable_quantity",
            item_exp_date: "item_exp_date",
            item_mfg_date: "item_mfg_date",
            item_batch_free_quantity: "item_batch_free_quantity",
            item_batch_unit_price: "item_batch_unit_price",
            item_batch_purchase_rate: "item_batch_purchase_rate",
            item_batch_discount_percentage: "item_batch_discount_percentage",
            item_batch_discount_amount: "item_batch_discount_amount",
            item_batch_tax_amount: "item_batch_tax_amount",
            item_batch_tax_percentage: "item_batch_tax_percentage",
            item_batch_final_purchase_rate: "item_batch_final_purchase_rate",
            item_batch_total_purchase_rate: "item_batch_total_purchase_rate",
            to_bin_id: "to_bin_id",
            to_bin_location: "to_bin_location",
          },
        ],
        total_sellable_quantity: "total_sellable_quantity",
      },
    ],
  },
];
const storeDetailsResult_sample = [
  {
    company: "COMAPNY_NAME",
    company_address: "COMPANY_LOCATION",
    company_telephone1: "COMPANY_PHONE",
    company_city: "COMPANY_CITY_CODE",
    company_gstn: "COMPANY_GST_NUMBER",
    company_email: "COMPANY_EMAIL",
    dl_no_20_20b: "DRUG_LICENSE_XX_XX",
    dl_no_21_21b: "DRUG_LICENSE_XX_XX",
    dl_no_21c: "DRUG_LICENSE_21C",
    store_id: "STORE_ID",
    company_logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQVa-2-bOT2c7AJwxiSHkrkwOkey9z9x16dA&s"
  }
];
export default {DebitNote_Sample,storeDetailsResult_sample};